import React, { useRef } from 'react';
import { View } from 'react-native';
import { useThreeJS } from '@components/imageHandling/components/thumbnails/3dViewer/hooks/useThreeJS';

const Web3DViewer = ({ modelUrl, style, C }) => {
  const containerRef = useRef(null);
  useThreeJS(containerRef, modelUrl, C);

  return (
    <View style={[{ flex: 1, width: '100%', height: '100%' }, style]}>
      <div
        ref={containerRef}
        style={{
          width: '100%',
          height: '100%',
          minHeight: '200px',
          background: C('Gray/Light/6'),
        }}
      />
    </View>
  );
};

export default Web3DViewer;
